import React from 'react';
import './Team.css';

const team = [
  {
    img: '/assets/uploads/tessy_methew.jpeg',
    name: 'Tessy Mathew',
    role: 'Founder',
  },
  {
    img: '/assets/uploads/Ancy.png',
    name: 'Ancy Mathew',
    role: 'Nurse Practitioner',
  },
];

const Team = () => {
  return (
    <section className="team-section">
      <div className="container">
        <div className="team-header">
          <h2 className="section-title">Meet our Team</h2>
        </div>

        <div className="team-grid">
          {team.map((m, i) => (
            <div className="team-card" key={i}>
              <div className="team-img-wrap">
                <img src={m.img} alt={m.name} />
              </div>
              <div className="team-info">
                <h3>{m.name}</h3>
                <p>{m.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
